enum Routes {
  HOME = '/',
  LOGIN = '/auth/login',
  LOGOUT = '/auth/logout',
  CHANGE_PASSWORD = '/auth/changepassword',
  SETTINGS = '/settings/settings',
  NOT_FOUND = '/:pathMatch(.*)*',
}

export default Routes;
